var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-signature-embedded-container"},[_c('div',{key:_vm.plotlyUID,ref:("signature_embed_container_" + _vm.plotlyUID),attrs:{"id":"dash-app"}})])}
var staticRenderFns = []

export { render, staticRenderFns }